import React, { useContext, useEffect, useState } from 'react'
import { ActionResponse, ErrorResponse, Dependence } from '../interfaces/type'
import { FaPencilAlt, FaTrash, FaPlus, FaFileExport } from 'react-icons/fa'
import AddDependenceModal from './addDependenceModal'
import EditDependenceModal from './editDependenceModal'
import { AuthContext } from '../providers/auth.provider'
import { addDependenceService, deleteDependenceService, editDependenceService, getPlaceDependence } from '../services/dependence.service'
import DeleteModal from './deleteModal'
import toast from 'react-hot-toast';

type Props = {
  data: Partial<Dependence>[]
  handleSearch: (s: string) => void
  handleChangeListDependence: (dependence: Partial<Dependence>) => void
}

const TableDependenceData = ({ data, handleSearch, handleChangeListDependence }: Props) => {
  const [addModal, setAddModal] = useState<Boolean>(false)
  const [editModal, setEditModal] = useState<Boolean>(false)
  const [deleteModal, setDeleteModal] = useState<Boolean>(false)
  const [errorUser, setErrorUser] = useState<ErrorResponse | null>(null)
  const [actionUser, setActionUser] = useState<Partial<Dependence>>()
  const [places, setPlaces] = useState<string[]>([])
  const [placeSelected, setPlaceSelected] = useState<string>("")

  const { auth, loginAuth } = useContext(AuthContext);

  useEffect(() => {
    const api = async () => {
      const response = await getPlaceDependence()
      setPlaces(response)
    }
    api()
  }, [])

  const handleAddUserSubmit = async (data: Partial<Dependence>) => {
    const response = await addDependenceService(data, auth.token)
    if (response.status === 200) {
      const res = (response as ActionResponse)
      loginAuth({ token: res.token })
      handleChangeListDependence(res.data ?? {})
      setAddModal(false)
      toast.success('Dependencia Agregado Correctamente!');
      setErrorUser(null);
    }
    if (response.status === 500) {
      setErrorUser((response as ErrorResponse))
    }
  }

  const handleEdit = (user: Partial<Dependence>) => {
    setActionUser(user)
    setEditModal(!editModal)
  }

  const handleEditUserSubmit = async (data: Partial<Dependence>) => {
    const response = await editDependenceService(data, auth.token)
    if (response.status === 200) {
      const res = (response as ActionResponse)
      loginAuth({ token: res.token })
      handleChangeListDependence(res.data ?? {})
      setEditModal(false)
      toast.success('Dependencia Editado Correctamente!');
      setErrorUser(null);
    }
    if (response.status === 500) {
      setErrorUser((response as ErrorResponse))
    }
  }

  const handleDelete = (dependence: Partial<Dependence>) => {
    setActionUser(dependence)
    setDeleteModal(!editModal)
  }

  const handleDeleteUserSubmit = async (id: string) => {
    const response = await deleteDependenceService(id, auth.token)
    if (response.status === 200) {
      const res = (response as ActionResponse)
      loginAuth({ token: res.token })
      handleChangeListDependence(res.data ?? {})
      setDeleteModal(false)
      toast.success('Dependencia Eliminado Correctamente!');
      setErrorUser(null);
    }
    if (response.status === 500) {
      setErrorUser((response as ErrorResponse))
    }
  }

  const handleChangePlace = (place:string) => {
    setPlaceSelected(place)
    handleSearch(placeSelected)
  }

  return (
    <div className="mx-auto mt-10 overflow-hidden">
      {
        addModal ? <AddDependenceModal handleModalAdd={() => setAddModal(!addModal)} handleAddDependenceSubmit={handleAddUserSubmit} error={errorUser} /> : null
      }
      {
        (editModal && actionUser) ? <EditDependenceModal dependence={actionUser} handleModalEdit={() => setEditModal(!editModal)} handleEditUserSubmit={handleEditUserSubmit} error={errorUser} /> : null
      }
      {
        (deleteModal && actionUser) ? <DeleteModal id={actionUser.id ?? ''} message={`Eliminar ${actionUser.name}?`} handleModal={() => setDeleteModal(!deleteModal)} handleSubmitModal={handleDeleteUserSubmit} error={errorUser} /> : null
      }
      <div className="flex flex-col">
        <div className="w-full">
          <div className="w-full flex flex-col md:flex-row my-2 gap-3">
            <div className="w-full md:w-1/4 flex flex-row items-center">
              <select name="rol" onChange={(e) => handleSearch(e.target.value)}
                className="
                                                      bg-gray-50 
                                                      border 
                                                      border-gray-300 
                                                      text-gray-900 
                                                      text-sm
                                                      block 
                                                      w-full 
                                                      p-2
                                                      "
              >
                 <option
                    value="TODO"
                  >
                    TODO
                  </option>
                {places.map((value) => (
                  <option
                    key={value}
                    value={value}
                  >
                    {value}
                  </option>
                ))}
              </select>
            </div>
            <div className='w-2/4'></div>
            <div className="w-full md:w-1/4 inline-flex justify-end">
              <button
                onClick={() => setAddModal(!addModal)}
                className='uppercase text-sm font-bold flex flex-row items-center justify-center bg-green-500 py-2 px-5 rounded-l text-white border border-solid border-white hover:bg-green-700 hover:shadow-lg mr-1 mb-1 ease-linear transition-all duration-150'
              >
                <FaPlus className='mr-2' /> Agregar
              </button>
            </div>
          </div>
          <div className="p-1.5 w-full inline-block align-middle">
            <div className="w-full overflow-x-auto border rounded-lg">
              <table className="w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase w-1/5">Lugar</th>
                    <th scope="col" className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase w-1/5">Dependencia</th>
                    <th scope="col" className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">Dirigido a</th>
                    <th scope="col" className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">Dirección</th>
                    <th scope="col" className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">Accion</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {
                    data.sort((a, b) => ((a.place ?? '') > (b.place ?? '') ? -1 : 1)).map(dependence => {
                      return (
                        <tr key={dependence.id}>
                          <td className="px-6 py-4 text-sm text-center text-gray-800">
                            <p>{dependence.place}</p>
                          </td>
                          <td className="px-6 py-4 text-sm text-center text-gray-800">
                            <p>{dependence.name}</p>
                          </td>
                          <td className="px-6 py-4 text-sm text-center text-gray-800">
                            <p>{dependence.to}</p>
                          </td>
                          <td className="px-6 py-4 text-sm text-center text-gray-800">
                            <p>{dependence.address}</p>
                          </td>
                          <td className="px-6 py-4 text-sm text-center font-medium">
                            <div className='inline-flex'>
                              <button onClick={() => handleEdit(dependence)}
                                className="inline-flex items-center justify-center bg-yellow-500 text-white w-8 h-8 hover:bg-yellow-700 hover:shadow-lg mr-2 rounded-full ease-linear transition-all duration-150"
                              >
                                <FaPencilAlt />
                              </button>
                              <button onClick={() => handleDelete(dependence)}
                                className="inline-flex items-center justify-center bg-red-500 text-white w-8 h-8 hover:bg-red-700 hover:shadow-lg mr-2 rounded-full ease-linear transition-all duration-150"
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default TableDependenceData